/**
 * Initialize accordion accessibility (WCAG 4.1.2)
 * Uses MutationObserver to sync aria-expanded with toggle state
 */
export function initAccordionAccessibility() {
  // Find all accordion triggers with aria-expanded
  const accordionTriggers = document.querySelectorAll('[data-toggle-trigger][aria-expanded]')

  accordionTriggers.forEach(trigger => {
    // Skip if already initialized
    if (trigger.dataset.ariaInitialized) return
    trigger.dataset.ariaInitialized = 'true'

    const toggleEl = trigger.closest('[data-toggle]')
    if (!toggleEl) return

    // Use MutationObserver to watch for class changes on the toggle element
    const observer = new MutationObserver(() => {
      const isOpen = toggleEl.classList.contains('open')
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    })

    observer.observe(toggleEl, {
      attributes: true,
      attributeFilter: ['class'],
    })

    // Set initial state
    const isOpen = toggleEl.classList.contains('open')
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
  })

  // Handle expand-all button for accordions
  const expandAllButtons = document.querySelectorAll('[data-expand-all]')
  expandAllButtons.forEach(btn => {
    // Skip if already initialized
    if (btn.dataset.ariaInitialized) return
    btn.dataset.ariaInitialized = 'true'

    const accordionSection = btn.closest('[b-tpl="accordion"]')
    if (!accordionSection) return

    // Watch all toggles in this accordion to update expand-all state
    const toggleEls = accordionSection.querySelectorAll('[data-toggle]')

    const updateExpandAllState = () => {
      const triggers = accordionSection.querySelectorAll('[data-toggle-trigger][aria-expanded]')
      const allOpen = Array.from(triggers).every(
        t => t.getAttribute('aria-expanded') === 'true'
      )
      btn.setAttribute('aria-expanded', allOpen ? 'true' : 'false')
    }

    toggleEls.forEach(toggleEl => {
      const observer = new MutationObserver(updateExpandAllState)
      observer.observe(toggleEl, {
        attributes: true,
        attributeFilter: ['class'],
      })
    })

    // Set initial state
    updateExpandAllState()
  })
}
